import CityPageTemplate from "../city-template/CityPageTemplate";
import { torranceConfig } from "./data";

export default function TorrancePage() {
  return <CityPageTemplate config={torranceConfig} />;
}